import { ReactNode } from 'react';

import { AutoCompleteOptionType } from './AutoComplete.types';
import { VALUE_IDENTIFIER_SEPARATOR } from './autoCompleteLite.constants';

// Allows options to be built and passed in from outside the component
export const buildAutoCompleteOption = ({
  label,
  searchString,
  value,
  valueIdentifier,
  nonInteractive,
  className,
}: {
  label: ReactNode;
  value: string;
  valueIdentifier?: string;
  searchString: string;
  nonInteractive?: boolean;
  className?: string;
}): AutoCompleteOptionType<string> => {
  return {
    value: `${valueIdentifier ? valueIdentifier + VALUE_IDENTIFIER_SEPARATOR : ''}${value}`,
    label,
    searchString,
    nonInteractive,
    className,
  };
};
